/**
 *   Created by wangyuelong on 2018/11/9
 */
import urlUtil from '../utility/url';
import { pageMap } from './pageMap';

/**
 * 用路由来表示当前业务，因为entry区分不了视频和小视频或者图集等，只能在前端使用
 * */
export default () => {
  if (!__CLIENT__) return '';
  const { pathname = '' } = urlUtil.parse(window.location.href);
  const path = pathname.replace(/[\d]/g, '') || 'unknown';
  return pageMap[path] || path;
};
